import React from 'react';
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';

import '../sass/app.scss';

createInertiaApp({
	resolve: (name) => require(`./Pages/${name}`),
	setup({ el, App, props }) {
		createRoot(el).render(<App {...props} />);
	},
	progress: {
		color: '#4B5563',
	},
});
